export default __webpack_public_path__ + "static/media/g4.905d4997.jpg";